'use client'

import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { Button } from '@components/Ackodrive/Button'
import { SEARCH } from '../constants/icons'
import styles from './TopSearchModal.module.scss'

const TopSearchModal = () => {
  const router = useRouter()

  return (
    <Button className={styles.searchTriggerButton} onClick={() => router.push('/search')}>
      <Image src={SEARCH} alt="search icon" width={20} height={20} loading="lazy" />
    </Button>
  )
}

export default TopSearchModal
